import Joi from 'joi-browser';
import React, {Component} from 'react';
import {Route, Switch, Redirect} from 'react-router-dom';
import './App.scss';
import toastr from 'toastr';
import $ from 'jquery';
import axios from "axios";
import * as Sentry from "@sentry/react";
import update from 'immutability-helper';
import Offline from "react-offline";
import NoInternetConnection from './components/common/NoInternetConnection';
import AccountVerification from './components/views/accountVerification/AccountVerification';
import AddFunds from './components/views/addFunds/AddFunds';
import ExistingPayment from './components/views/addFunds/ExistingPayment';
import SubscriptionConfirmation from './components/views/addFunds/SubscriptionConfirmation';
import Checkout from './components/views/Checkout';
import CheckoutConfirmation from './components/views/CheckoutConfirmation';
import CranstenTest from './components/views/CranstenTest';
import Maintenance from './components/views/Maintenance';
import InsertPhone from './components/views/onboardingFlow/InsertPhone';
import PhoneNumbers from './components/views/onboardingFlow/PhoneNumbers';
import PhoneVerification from './components/views/onboardingFlow/PhoneVerification';
import Pricing from "./components/views/Pricing";

import Login from './components/views/Login'
import RedeemCode from './components/views/RedeemCode';
import SubscriptionPlans from './components/views/SubscriptionPlans'
import Register from './components/views/Register'
import EmailVerification from './components/views/onboardingFlow/EmailVerification';
import Logout from './components/views/Logout'
import ForgotPassword from './components/views/ForgotPassword'
import ResetPassword from './components/views/ResetPassword'
import RecoverySent from './components/views/RecoverySent'
import PasswordUpdated from './components/views/PasswordUpdated'
import Main from './components/layouts/Main'
// import Feed from './components/views/Feed'
import InsertName from './components/views/onboardingFlow/InsertName';
import CreateTeam from './components/views/onboardingFlow/CreateTeam';
import InsertCompany from './components/views/onboardingFlow/InsertCompany';
import TeamMembers from './components/views/onboardingFlow/TeamMembers';
import ChooseTeam from './components/views/onboardingFlow/ChooseTeam';
import FeedName from './components/views/onboardingFlow/FeedName';
import FeedSource from './components/views/onboardingFlow/FeedSource';
import RssFeedSource from './components/views/onboardingFlow/RssFeedSource';
import ManualFeedSource from './components/views/onboardingFlow/ManualFeedSource';
import DistributionPlatforms from './components/views/onboardingFlow/DistributionPlatforms';
import PrivacyPolicy from './components/views/PrivacyPolicy'
import * as authService from './services/authService';
import {getCurrentUserId, getJwt, setCurrentUserName} from './services/authService';
import http from './services/httpService';
import {persistent_menu, persistent_menu_start_it, persistent_menu_telegraf} from "./components/constants/constants";
import ConnectBotToPageModal from './components/modals/ConnectBotToPageModal'
import NotFound from "./components/views/NotFound";
import ConnectViberModal from './components/modals/ConnectViberModal';
import ReactGA from 'react-ga';
import ReactPixel from 'react-facebook-pixel';

// import moment from 'moment';
// import momentTimezone from 'moment-timezone';
import {zonedTimeToUtc, utcToZonedTime, format} from 'date-fns-tz';

const facebook_app_graph_url = process.env.REACT_APP_FB_URL;
const facebook_app_marketing_url = process.env.REACT_APP_FB_MARKETING_URL;

// If on this.props.history.push to some screen white screen is shown without errors or not connected errors <Switch> in Offline should be checked
// because it shows alternative screens flow for stoping access to screens without logging in, and probably there is no screen you're navigating to

// For removing file from all commits on git repository bfg should be renamed to bfg.java and placed in root directory
// and command that should be run from root directory is    java -jar bfg.java --delete-files .env

// For gitignore change to work on existing repository you have to first empty cache and after that add . everything again.
// git rm -r --cached .
// git add .
// git commit -m ". gitignore is now working"

class App extends Component {


    constructor(props) {
        super(props);
        this.state = {
            user: {
                sources: {
                    data: []
                }, facebook_pages: {
                    data: []
                }, facebook_pages_shared: [], //feeds_shared: []
            },
            platforms_enabled: [],
            selected_source: "",
            selected_source_rss: "",
            selected_source_data: '',
            reassign_feed_name: "",
            source_active: true,
            editing: false,
            checked_send_all: false,
            checked_sources: [],
            checked_channels: {
                facebook: [], web_push: false, slack: false, twitter: false, linkedin: false
            },
            visible_email_modal: false,
            visible_password_modal: false,
            visible_team_modal: false,
            visible_team_modal_admins: false,
            visible_invite_admins_modal: false,
            visible_team_edit_modal: false,
            visible_delete_team_modal: false,
            visible_reassign_feed_modal: false,
            visible_post_reach_modal: false,
            visible_connect_bot_to_page_modal: false,
            visible_delete_feed_modal: false,
            visible_feed_info_edit_modal: false,
            visible_rss_delete_modal: false,
            visible_web_push_instructions_modal: false,
            remove_activation_email_modal: false,
            visible_facebook_video_modal: false,
            visible_webpush_video_modal: false,
            visible_overview_video_modal: false,
            visible_contact_support_modal: false,
            visible_connect_viber_modal: false,
            visible_tags_modal: false,
            visible_delete_tag_modal: false,
            visible_edit_tag_modal: false,
            visible_delete_subscribers_modal: false,
            feed_id: "",
            post_reach_subscribers_count: 0,
            fb_sent: 0,
            postStats: [],
            count_push_subscrib: 0,
            count_fb_subscrib: 0,
            count_total_subscrib_sent: 0,
            count_not_sent: 0,
            team_name: "",
            team_id: "",
            admin_id: "",
            feed_in_team: false,
            added_by_other_admin_to_shared: false,
            rss_valid: false,
            target_page_to_connect: {slot: ""},
            wp_spinner: false,
            team_added: {},
            teams: [],
            teams_in: [],
            pending_admin: false,
            showStarted: true,
            isOnline: true,
            loadingSource: false,
            tags: [],
            filteredTags: [],
            tagsLoading: false,
            tagsPageSize: '',
            tag_id: '',
            tag_name: '',
            sortTagsColumn: {path: 'dateCreated', order: 'asc'},
            searchTagsString: '',
            tagsOnlyNames: [],
            deleteSubscribersIds: [],
            deleteSubscribersPageSize: '',
            deleteSubscribersPage: '',
            deleteSubscribersType: '',
            deleteSubscribersIndicator: 1,
            fbError: '',
            plansData: '',
            subscriptionFailedProjectId: ''
        };
    }

    handleTagsSort = path => {
        if (this.state.sortTagsColumn.order === 'desc') {
            this.setState({sortTagsColumn: {path, order: 'asc'}})
        } else {
            this.setState({sortTagsColumn: {path, order: 'desc'}})
        }

        //console.log('tags sorted:', this.state.sortTagsColumn.order)

    };


    dontShowStarted = () => {
        localStorage.setItem("dontShowAgain", true);
        this.setState({showStarted: false})
        // ReactGA.event({
        //     category: 'Click',
        //     action: 'Hide tutorial videos',
        //     label: '',
        //     nonInteraction: true
        // });
    };
    hideStarted = () => {
        this.setState({showStarted: false})
        // ReactGA.event({
        //     category: 'Click',
        //     action: 'Hide tutorial videos',
        //     label: '',
        //     nonInteraction: true
        // });
    };


    appPropagateUserData = (user) => {
        //console.log('appPropagateUserDAta: ', user)
        this.setState({
            user
        });
    };

    appPropagateUserPlatforms = (data) => {

        if (!data) {
            this.setState({
                platforms_enabled: ['fb']
            });
        } else {
            this.setState({
                platforms_enabled: data
            })
        }
    };

    loadingSourceChange = (bool) => {
        this.setState({
            loadingSource: bool
        })
    };

    appPropagateTeams = async (data) => {
        // console.log("teams", teams);
        await this.setState({
            teams: data.teams.data, teams_in: data.teams_in.data
        });
    };

    filterTags = (item) => {

        //console.log('filter item:', item);

        return this.state.tags.filter((t) => {
            return t.tag.toLowerCase().includes(item.toLowerCase());
        });
    };

    toggleConnect = async () => {
        const e_target_page_to_connect = this.state.target_page_to_connect;
        // console.log("MAIN MAIN toggleConnect e_target_page_to_connect ", e_target_page_to_connect);
        const FB_URL = facebook_app_graph_url;
        let pg_id = e_target_page_to_connect.id;
        let pg_token = e_target_page_to_connect.attributes.value.nodeValue;
        let feed_id = e_target_page_to_connect.attributes.name.nodeValue;
        let page_connected = e_target_page_to_connect.title;
        //let missing_permissions = [];
        //console.log("MAIN MAIN toggleConnect e_target_page_to_connect ", e_target_page_to_connect);
        //console.log("MAIN MAIN toggleConnect feed_id ", feed_id);
        //console.log("MAIN MAIN toggleConnect this.state.selected_source ", this.state.selected_source);
        if (feed_id && feed_id.toString() !== this.state.selected_source.toString()) {
            toastr.error("Page not connected to current workspace. Please disconnect page from the workspace it is connected to!");
        } else {
            // U N C O M M E N T
            //try {
            //    const resultzzzzz = await axios.get("https://graph.facebook.com/me/permissions?access_token=EAAGDF6WFdgwBAABd0Xh3XCuisaZCVhpxenpS1Rn2ZCgGYLa5ejvn1Xp5XAPwzd8MI5hu2ZCAmFIqPva70z3Qj9ZAUkdIKpQZAuanrdrAJE6KZBfcszjGvxxCNo90ny4dFqYvUgqPCvWtzr7JlK4eueSpErYnnKHhbZBaIerQGKYZCgZDZD");
            //
            //    let count_missing_permissions = 0;
            //    resultzzzzz.data.data.forEach(function (peerm) {
            //        //console.log("toggleConnect STATUS", peerm.status);
            //        if (peerm.status !== "granted") {
            //            missing_permissions[count_missing_permissions] = peerm.permission;
            //            count_missing_permissions++;
            //        }
            //    });
            //    if (missing_permissions.length > 0) {
            //        alert("missing_permissions: ", missing_permissions);
            //    }
            //
            //}
            //catch (ex) {
            //    if (ex.response && ex.response.status === 404)
            //        toastr.error("Something went wrong... Please refresh and try again.");
            //    if (ex.response && ex.response.status === 401)
            //    {
            //        //let errors = { ...this.state.errors }
            //        //console.log(ex.response.data);
            //        toastr.error(ex.response.data.message);
            //        //window.location = "/";
            //        this.props.history.push('/logout');
            //    }
            //}

            let source_rss = this.state.selected_source_rss;

            //console.log("MAIN MAIN toggleConnect source_rss ", source_rss);

            var url_facebook_graph = FB_URL + pg_id + '/subscribed_apps?access_token=' + pg_token + '&subscribed_fields=messages,message_deliveries,messaging_optins,messaging_postbacks';
            var url_facebook_graph_delete = FB_URL + pg_id + '/subscribed_apps?access_token=' + pg_token;
            var url_facebook_get_started = FB_URL + 'me/thread_settings?access_token=' + pg_token;
            var url_facebook_menu = FB_URL + 'me/messenger_profile?access_token=' + pg_token;

            var headers_get_started = {ContentType: "application/json"};

            let paramsToSend = {
                page_connected: page_connected, feed_id: feed_id
            };
            //console.log("Main paramsToSend ", paramsToSend);
            try {
                if (page_connected !== "Connected") {
                    const result = await axios.post(url_facebook_graph, {
                        headers: {
                            'Access-Control-Allow-Origin': '*'
                        }
                    });

                    //console.log("toggleConnect url_facebook_graph result", result);
                    if (!result) {
                        toastr.error("Facebook api connecting app problem. :(  Please log in again.");
                    } else {
                        page_connected = "Connected";
                        paramsToSend = {
                            page_connected: page_connected, feed_id: feed_id
                        };
                        var url_api = '/api/user/' + getCurrentUserId() + '/page/' + pg_id;
                        var headers_def = {authorization: getJwt()};

                        var params_start = {
                            "setting_type": "call_to_actions", "thread_state": "new_thread", "call_to_actions": [{
                                "payload": "Start"
                            }]
                        };
                        try {
                            const res = await http.patch(url_api, paramsToSend, {headers: headers_def});
                            const data = res.data.data;
                            //console.log("toggleConnect url_api data", data);
                            if (!data) {
                                toastr.error("res id does not match. :(  Please log in again.");
                                this.props.history.push('/logout');
                            } else {
                                //let user = data;
                                this.setState({
                                    user: Object.assign({}, this.state.user, {
                                        facebook_pages: data.facebook_pages
                                    })
                                });

                                // try {
                                //     const res_get_started = await axios.post(url_facebook_get_started, params_start, {headers: headers_get_started});
                                //     //console.log("toggleConnect res_get_started", res_get_started);
                                //     if (res_get_started) {
                                //
                                //     }
                                // } catch (ex) {
                                //     //console.log("ex.response", ex.response);
                                //     if (ex.response && ex.response.status === 404)
                                //         toastr.error("Something went wrong... Please refresh and try again.");
                                //
                                //     if (ex.response && ex.response.status === 403) {
                                //         toastr.error(ex.response.data.error.message);
                                //     }
                                //     if (ex.response && ex.response.status === 401) {
                                //         //let errors = { ...this.state.errors }
                                //         //console.log(ex.response.data);
                                //         toastr.error(ex.response.data.message);
                                //         //window.location = "/";
                                //         this.props.history.push('/logout');
                                //     }
                                // }

                                let params_persistent_menu = persistent_menu;
                                if (source_rss.includes('telegraf')) {
                                    params_persistent_menu = persistent_menu_telegraf;
                                } else if (source_rss.includes('startit') || source_rss.includes('nolimithub')) {
                                    params_persistent_menu = persistent_menu_start_it;
                                }
                                // try {
                                //     const res_facebook_menu = await axios.post(url_facebook_menu, params_persistent_menu, {headers: headers_get_started});
                                //     //console.log("toggleConnect res_facebook_menu", res_facebook_menu);
                                //     if (res_facebook_menu) {
                                //
                                //     }
                                // } catch (ex) {
                                //     //console.log("ex.response", ex.response);
                                //     if (ex.response && ex.response.status === 404)
                                //         toastr.error("Something went wrong... Please refresh and try again.");
                                //     if (ex.response && ex.response.status === 403)
                                //         toastr.error(ex.response.data.error.message);
                                //     if (ex.response && ex.response.status === 401) {
                                //         //let errors = { ...this.state.errors }
                                //         //console.log(ex.response.data);
                                //         toastr.error(ex.response.data.message);
                                //         //window.location = "/";
                                //         this.props.history.push('/logout');
                                //     }
                                // }
                            }
                        } catch (ex) {
                            //console.log("ex.response", ex.response);
                            if (ex.response && ex.response.status === 404) toastr.error("Something went wrong... Please refresh and try again.");
                            if (ex.response && ex.response.status === 401) {
                                //let errors = { ...this.state.errors }
                                //console.log(ex.response.data);
                                toastr.error(ex.response.data.message);
                                //window.location = "/";
                                this.props.history.push('/logout');
                            }
                        }
                    }
                } else {
                    toastr.info("Disconecting... Please wait...");
                    try {
                        const result = axios.delete(url_facebook_graph_delete);
                        //console.log("toggleConnect delete(url_facebook_graph result", result);

                        if (!result) {
                            toastr.error("Facebook api disconnecting app problem.. :(  Please log in again.");
                        } else {
                            page_connected = "Not Connected";
                            paramsToSend = {
                                page_connected: page_connected, feed_id: feed_id
                            };
                            url_api = '/api/user/' + getCurrentUserId() + '/page/' + pg_id;
                            headers_def = {authorization: getJwt()};
                            try {
                                const res = await http.patch(url_api, paramsToSend, {headers: headers_def});
                                const data = res.data.data;
                                //console.log("toggleConnect delete-patch(url_api data", data);
                                if (!data) {
                                    toastr.error("res removing id does not match. :(  Please log in again.");
                                    this.props.history.push('/logout');
                                } else {
                                    //let user = data;
                                    this.setState({
                                        user: Object.assign({}, this.state.user, {
                                            facebook_pages: data.facebook_pages
                                        })
                                    });
                                    //this.setState({user: data});
                                    //let rmv_persistent_menu = {
                                    //    "fields":[
                                    //        "persistent_menu"
                                    //    ]
                                    //};

                                    // try {
                                    //     const data_rmv_persistent_menu = await axios.delete(url_facebook_menu, {
                                    //         params: {
                                    //             "fields": [
                                    //                 "persistent_menu"
                                    //             ]
                                    //         }
                                    //     }, {headers: headers_get_started});
                                    //     //console.log("toggleConnect delete(url_facebook_menu data_rmv_persistent_menu", data_rmv_persistent_menu);
                                    //     if (data_rmv_persistent_menu) {
                                    //
                                    //     }
                                    // } catch (ex) {
                                    //     //console.log("ex.response", ex.response);
                                    //     if (ex.response && ex.response.status === 404)
                                    //         toastr.error("Something went wrong... Please refresh and try again.");
                                    //     if (ex.response && ex.response.status === 403)
                                    //         toastr.error("DELETING persistent_menu ERROR - " + ex.response.data.error.message);
                                    //     if (ex.response && ex.response.status === 401) {
                                    //         //let errors = { ...this.state.errors }
                                    //         //console.log(ex.response.data);
                                    //         toastr.error(ex.response.data.message);
                                    //         //window.location = "/";
                                    //         this.props.history.push('/logout');
                                    //     }
                                    // }
                                }
                            } catch (ex) {
                                //console.log("ex.response", ex.response);
                                if (ex.response && ex.response.status === 404) toastr.error("Something went wrong... Please refresh and try again.");
                                if (ex.response && ex.response.status === 403) toastr.error(ex.response.data.error.message);
                                if (ex.response && ex.response.status === 401) {
                                    //let errors = { ...this.state.errors }
                                    //console.log(ex.response.data);
                                    toastr.error(ex.response.data.message);
                                    //window.location = "/";
                                    this.props.history.push('/logout');
                                }
                            }
                        }

                    } catch (ex) {
                        //console.log("ex.response", ex.response);
                        if (ex.response && ex.response.status === 404) toastr.error("Something went wrong... Please refresh and try again.");
                        if (ex.response && ex.response.status === 403) toastr.error("DELETING ERROR - " + ex.response.data.error.message);
                        if (ex.response && ex.response.status === 401) {
                            //let errors = { ...this.state.errors }
                            //console.log(ex.response.data);
                            toastr.error(ex.response.data.message);
                            //window.location = "/";
                            this.props.history.push('/logout');
                        }
                    }

                }
            } catch (ex) {
                if (ex.response && ex.response.status === 404) toastr.error("Something went wrong... Please refresh and try again.");
                if (ex.response && ex.response.status === 401) {
                    //let errors = { ...this.state.errors }
                    //console.log(ex.response.data);
                    toastr.error(ex.response.data.message);
                    //window.location = "/";
                    this.props.history.push('/logout');
                }
            }
        }
        toastr.success("Facebook Page is successfully disconnected");
        this.setState({
            visible_connect_bot_to_page_modal: false
        })
    };

    closeModal = () => {
        this.setState({
            visible_email_modal: false,
            visible_delete_subscribers_modal: false,
            visible_password_modal: false,
            visible_team_modal: false,
            visible_team_modal_admins: false,
            visible_invite_admins_modal: false,
            visible_team_edit_modal: false,
            visible_delete_team_modal: false,
            visible_post_reach_modal: false,
            visible_connect_bot_to_page_modal: false,
            visible_delete_feed_modal: false,
            visible_reassign_feed_modal: false,
            visible_feed_info_edit_modal: false,
            visible_rss_delete_modal: false,
            visible_web_push_instructions_modal: false,
            visible_facebook_video_modal: false,
            visible_webpush_video_modal: false,
            visible_overview_video_modal: false,
            visible_contact_support_modal: false,
            visible_connect_viber_modal: false,
            visible_tags_modal: false,
            visible_delete_tag_modal: false,
            visible_edit_tag_modal: false
        })
    };

    closeModalActive = () => {
        this.setState({
            remove_activation_email_modal: true
        })
    };

    openModal = (e, data = "") => {
        // console.log('modal data: ', data);
        //console.log("openModal e.target ", e.target);

        let btn = e.target.id;
        //alert(btn);
        if (btn === 'delete_contacts') {
            //console.log('delete subscribers data 1: ', data);
            this.setState({
                visible_delete_subscribers_modal: true,
                deleteSubscribersIds: data.deleteSubscriberIds,
                deleteSubscribersPageSize: data.pageSize,
                deleteSubscribersPage: data.currentPage,
                deleteSubscribersType: data.subscribersType
            })
        }
        if (btn === 'delete_subscribers') {
            //console.log('delete subscribers data 1: ', data);
            this.setState({
                visible_delete_subscribers_modal: true,
                deleteSubscribersIds: data.deleteSubscriberIds,
                deleteSubscribersPageSize: data.pageSize,
                deleteSubscribersPage: data.currentPage,
                deleteSubscribersType: data.subscribersType
            })
        } else if (btn === 'edit_tag') {
            //console.log('edit tag open:', data);
            // ReactGA.event({
            //     category: 'Click',
            //     action: 'Tags - Edit tag open modal',
            //     userId: getCurrentUserId(),
            //     label: '',
            //     nonInteraction: true
            // });
            this.setState({
                visible_edit_tag_modal: true, tag_id: data.id, tag_name: data.tag

            })
        } else if (btn === "delete_tag") {
            // ReactGA.event({
            //     category: 'Click',
            //     action: 'Tags - Delete tag open modal',
            //     userId: getCurrentUserId(),
            //     label: '',
            //     nonInteraction: true
            // });
            this.setState({
                visible_delete_tag_modal: true, tag_id: data.id, tag_name: data.tag

            })
        } else if (btn === "tags_btn") {
            // ReactGA.event({
            //     category: 'Click',
            //     action: 'Tags - Add new tag open modal',
            //     userId: getCurrentUserId(),
            //     label: '',
            //     nonInteraction: true
            // });
            this.setState({
                visible_tags_modal: true,

            })
        } else if (btn === "email_btn") {
            this.setState({
                visible_email_modal: true
            })
        } else if (btn === "team_btn") {
            this.setState({
                visible_team_modal: true
            })
        } else if (btn === "team_edit_btn") {
            this.setState({
                visible_team_edit_modal: true, team_name: e.target.title || "", team_id: e.target.name || ""
            })
        } else if (btn === "reassign_feed") {
            this.setState({
                visible_reassign_feed_modal: true,
                team_id: e.target.slot || "",
                feed_id: e.target.name || "",
                reassign_feed_name: e.target.title || ""
            })
        } else if (btn === "feed_info_edit") {
            this.setState({
                visible_feed_info_edit_modal: true
            })
            localStorage.setItem('name', e.target.name)
        } else if (btn === "autopush_edit_remove") {
            this.setState({
                visible_rss_delete_modal: true
            })
            // localStorage.setItem('name', e.target.name)
        } else if (btn === "web_push_instructions") {
            this.setState({
                visible_web_push_instructions_modal: true
            })
            // localStorage.setItem('name', e.target.name)
        } else if (btn === "connect_viber") {
            this.setState({
                visible_connect_viber_modal: true
            })
            // localStorage.setItem('name', e.target.name)
        } else if (btn === "fb_video_modal") {
            this.setState({visible_facebook_video_modal: true})

        } else if (btn === "webpush_video_modal") {
            this.setState({visible_webpush_video_modal: true})

        } else if (btn === "overview_video_modal") {
            this.setState({visible_overview_video_modal: true})

        } else if (btn === "contact_support_modal") {
            this.setState({visible_contact_support_modal: true})
        } else if (btn === "add_admin") {

            // ReactGA.event({
            //     category: 'Click',
            //     action: 'Teams - Add team admin open modal',
            //     userId: getCurrentUserId(),
            //     label: '',
            //     nonInteraction: true
            // });

            // console.log("openModal add_admin data ", data);
            //console.log("openModal add_admin team ", JSON.parse(localStorage.team_clicked));
            //localStorage.removeItem('team_clicked');
            //console.log("openModal e.target.title ",  e.target.title);
            this.setState({
                //visible_team_modal: false,
                visible_team_modal_admins: true, team_name: e.target.title || "", team_id: e.target.slot || ""
            });

// alert(btn);
            let sources_checked = data.feeds.map(src => {
                // console.log("acceptModal sources_checked src", src);
                return {id: src.id, name: src.name, checked: false}
            });
            // console.log("acceptModal data.feeds", data.feeds);
            // alert(btn+5555);
            this.setState({checked_sources: sources_checked});
            // }
        } else if (btn === "add_admin_spec_feed" || btn === "add_admin_spec_shared_feed") {


            // ReactGA.event({
            //     category: 'Click',
            //     action: 'Teams - Add admin to workspace open modal',
            //     userId: getCurrentUserId(),
            //     label: '',
            //     nonInteraction: true
            // });


            this.setState({
                visible_invite_admins_modal: true, //in this case feed name and feed id is placed into  team_name and team_id
                team_name: e.target.title || "", team_id: e.target.slot || ""
            });
            if (btn === "add_admin_spec_shared_feed") {
                this.setState({
                    added_by_other_admin_to_shared: true
                });
            }
        } else if (btn === "team_delete_btn" || btn === "remove_admin_from_feed" || btn === "remove_pending_from_feed" || btn === "remove_pending_from_team") {

            this.setState({
                visible_delete_team_modal: true,
                team_name: e.target.title || "",
                team_id: e.target.name || "",
                admin_id: ""
            });

            if (e.target.slot) {
                this.setState({
                    team_name: e.target.slot || "", team_id: e.target.title || "", admin_id: e.target.name || ""
                });

                if (btn === "remove_admin_from_feed") {
                    this.setState({
                        feed_in_team: true, pending_admin: false
                    });
                } else if (btn === "remove_pending_from_feed") {
                    this.setState({
                        feed_in_team: true, pending_admin: true
                    });
                } else if (btn === "remove_pending_from_team") {
                    this.setState({
                        pending_admin: true
                    });
                }

                if (e.target.slot === "remove_feed_from_team") {
                    // alert(btn);
                    this.setState({
                        team_name: e.target.name, admin_id: ""
                    });
                }
                this.setState({
                    admin_in_team: false
                });
            } else {

                this.setState({
                    admin_in_team: true
                });
            }

        } else if (btn === "broadcastClick") {


            //console.log('data in app.js - broadcastClick: ', data);
            if (data.count_push_subscrib !== -1) {

                this.setState({
                    visible_post_reach_modal: true,
                    post_reach_subscribers_count: data.count_total_subscrib_sent || 0,
                    fb_sent: data.fb_sent,
                    count_push_subscrib: data.count_push_subscrib === -2 ? 0 : data.count_push_subscrib,
                    count_fb_subscrib: data.count_fb_subscrib,
                    count_total_subscrib_sent: data.count_total_subscrib_sent || 0,
                    fbError: data.error
                })

            } else {
                if (data.type === 'web_push_notification' && !data.count_push_subscrib) {
                    toastr.warning("It seems that you don't have any Web Push subscribers on the selected channels.");
                }
                if (data.type === 'fb_notification' && !data.count_fb_subscrib && data.pages && data.pages.length > 0 && data.postStats && data.postStats.length > 0) {
                    toastr.warning("It seems that you don't have any Facebook subscribers on the selected channels.");
                }
            }

        } else if (e.target.title && e.target.title.includes("Connected")) {

            this.setState({
                target_page_to_connect: e.target
            });

            this.setState({
                visible_connect_bot_to_page_modal: true
            });

        } else {
            this.setState({
                visible_password_modal: true
            })
        }
    };

    acceptModal = async (e, data, team_id = null, emails = null, buttonId = null) => {
        this.setState({
            visible_email_modal: false,
            visible_password_modal: false,
            visible_team_modal: false,
            visible_team_edit_modal: false,
            visible_team_modal_admins: false,
            visible_invite_admins_modal: false,
            visible_reassign_feed_modal: false,
            visible_delete_team_modal: false,
            visible_feed_info_edit_modal: false,
            visible_rss_delete_modal: false,
            visible_facebook_video_modal: false,
            visible_webpush_video_modal: false,
            visible_overview_video_modal: false,
            visible_contact_support_modal: false,
            visible_connect_viber_modal: false,
            visible_tags_modal: false,
            visible_delete_tag_modal: false,
            visible_edit_tag_modal: false,
            visible_delete_subscribers_modal: false
        });
        let btn = '';
        //console.log('e:', e);
        //console.log('e target id:', e.target.id);
        if (e !== null) {
            btn = e.target.id;
        } else {
            btn = buttonId
        }
        //console.log('e target id:', btn);
        const user_id = getCurrentUserId();

        // console.log("acceptModal data", data);
        //alert(btn);

        try {
            if (btn === 'delete_subscribers') {

                try {

                    //  console.log(data.tagId)
                    //     console.log('net tag name:', data.new_tag)
                    //console.log('delete subscriber ids: ', this.state.deleteSubscribersIds);
                    let response = await http.delete('api/feed/' + this.state.selected_source + '/subscribers/' + this.state.deleteSubscribersType + '/page_size/' + this.state.deleteSubscribersPageSize + '?page=' + this.state.deleteSubscribersPage, {
                        headers: {authorization: getJwt()}, data: {subscriber_ids: this.state.deleteSubscribersIds}

                    });
                    //console.log('delete subscribers response:', response);

                    toastr.success('Subscribers successfully deleted.');

                    let indicator = '';
                    if (this.state.deleteSubscribersIndicator === 0) {
                        indicator = 1
                    } else {
                        indicator = 0
                    }
                    await this.setState({deleteSubscribersIndicator: indicator});

                } catch (ex) {

                    if (ex.response && ex.response.status === 404) toastr.error("Something went wrong... Please try later or contact support.");
                    if (ex.response && ex.response.status === 401) {
                        toastr.error(ex.response.data.message);

                    }
                    let indicator = '';
                    if (this.state.deleteSubscribersIndicator === 0) {
                        indicator = 1
                    } else {
                        indicator = 0
                    }
                    await this.setState({deleteSubscriberIndicator: indicator});
                }

            } else if (btn === 'edit_tag') {
                //console.log('edit tag data:', data);
                try {
                    //  console.log(data.tagId)
                    //     console.log('net tag name:', data.new_tag)

                    let tags = await http.patch('api/user/' + this.state.user.id + '/source/' + this.state.selected_source + '/tag/' + data.id, {tag: data.editedTagName}, {headers: {authorization: getJwt()}});
                    tags = tags.data.data;
                    // console.log('new tag name:',data.editedTagName);
                    // console.log('edit tag call:','/api/user/' + this.state.user.id + '/source/' + this.state.selected_source + '/tag/' + data.id);
                    //console.log('edited tags:', tags)

                    // tags = tags.data.data;
                    await this.setState({tags, filteredTags: tags})

                } catch (ex) {
                    if (ex.response && ex.response.status === 404) toastr.error("Something went wrong... Please refresh and try again.");
                    if (ex.response && ex.response.status === 401) {
                        toastr.error(ex.response.data.message);

                    }
                }
                // const tag = this.state.tags.filter(t => t.id === data.id);
                // // tag.tagName = data.editedTagName;
                // console.log('tag editing:', tag);
                // tag[0].tagName = data.editedTagName;
                // console.log('changed tag:', tag[0])
            } else if (btn === 'delete_tag') {
                try {

                    //  console.log(data.tagId)
                    //     console.log('net tag name:', data.new_tag)
                    let response = await http.delete('api/user/' + this.state.user.id + '/source/' + this.state.selected_source + '/tag/' + data.tagId, {headers: {authorization: getJwt()}});
                    //console.log('delete tag response:', response);
                    let tags = await this.state.tags;
                    toastr.success(response.data.message);

                    //console.log('tags before delete filtering:', tags);
                    let filteredTags = tags.filter(t => t.id !== data.tagId);

                    //console.log('tags after delete filtering:', filteredTags);

                    await this.setState({tags: filteredTags, filteredTags: filteredTags});


                } catch (ex) {
                    if (ex.response && ex.response.status === 404) toastr.error("Something went wrong... Please refresh and try again.");
                    if (ex.response && ex.response.status === 401) {
                        toastr.error(ex.response.data.message);

                    }
                }
            } else if (btn === 'create_tag') {
                this.handleCreateTag(data.new_tag)

            } else if (btn === "change_email") {
                //console.log('change email entered');
                const result = await http.patch('api/user/' + user_id + '/email', data, {headers: {authorization: getJwt()}});

                if (result && result.status === 200) {
                    toastr.success('Your new email is ' + result.data.data.email);
                    this.setState({
                        user: Object.assign({}, this.state.user, {
                            email: result.data.data.email
                        })
                    });
                } else {
                    toastr.info(result);
                }
            } else if (btn === "finish_team_btn") {
                // alert(btn);
                //edit team name
                //console.log("acceptModal finish_team_btn ", btn);
                //console.log("acceptModal data", data);
                const result = await http.patch('api/user/' + getCurrentUserId() + '/team/' + data.team_id, data, {headers: {authorization: getJwt()}});
                if (result) {
                    // console.log("change_team result", result);
                    let result_data = result.data;
                    // console.log("change_team result_data", result_data);
                    this.setState({
                        teams: result_data.teams.data, teams_in: result_data.teams_in.data
                    });
                }
            } else if (btn === "invite_team") {
                //new team created, admins invited
                //console.log("acceptModal invite_team ", btn);
                //console.log("acceptModal data", data);
                const result = await http.post('api/user/' + getCurrentUserId() + '/team', data, {headers: {authorization: getJwt()}});
                if (result) {

                }
            } else if (btn === "finish_team") {
                //new team created, but no admins invited
                //console.log("acceptModal finish_team ", btn);
                //console.log("acceptModal data", data);
                const result = await http.post('api/user/' + getCurrentUserId() + '/team', data, {headers: {authorization: getJwt()}});
                if (result) {
                    // console.log("finish_team result", result);
                    let team_added = result.data.data;
                    this.setState({
                        team_added: team_added
                    });

                }
            } else if (btn === "change_team") {


                const userId = await getCurrentUserId();
                let resp = '';
                //console.log('CHANGE TEAM', userId);

                if (userId && emails.length > 0) {


                    resp = await http.post('api/user/' + userId + '/team/' + team_id + '/member', {emails: emails}, {headers: {authorization: getJwt()}});


                }
                //console.log('result: ', resp);
                this.setState({teams: resp.data.teams.data, teams_in: resp.data.teams_in.data})
                //   this.props.history.push('/dashboard')

            } else if (btn === "invite_to_feed") {

                //add admins to specific feed in team
                //console.log("acceptModal change_team ", btn);
                // console.log("acceptModal data.email", data.email);
                // const str = 'Browse appdividend.com and enjoy coding';
                const userId = await getCurrentUserId();
                let resp = '';
                //console.log('CHANGE TEAM', userId);

                if (userId && emails.length > 0) {


                    resp = await http.post('api/user/' + userId + '/feed/' + team_id + '/admin', {emails: emails}, {headers: {authorization: getJwt()}});


                }
                //console.log('result: ', resp);
                this.setState({teams: resp.data.teams.data, teams_in: resp.data.teams_in.data})
            } else if (btn === "reasign_feed_btn") {
                if (data.team_id && data.feed_id) {
                    let data_send = {team_id: data.team_id};
                    const result = await http.post('api/user/' + getCurrentUserId() + '/team/feed/' + data.feed_id, data_send, {headers: {authorization: getJwt()}});
                    if (result) {
                        // const teams = await http.get('api/user/' + authService.getCurrentUserId() + '/teams');
                        //console.log("invite_to_feed result", result);

                        await this.appPropagateTeams(result.data)

                        // this.setState({
                        //     teams: [result_data.data, ...find_team_feed, ...teamsfiltered]
                        // });
                    }
                }

            } else if (btn === "feed_info_edit") {
                const feed_id = JSON.parse(localStorage.source_clicked)
                const name = localStorage.name
                const result = await http.patch('api/feed/' + feed_id, {name}, {headers: {authorization: getJwt()}});

                const feedData = await result.data;

                this.updateSources(feedData)

                if (result && result.status === 200) {
                    toastr.success('Your new workspace name is ' + result.data.data.name);
                } else {
                    toastr.info(result);
                }
            } else if (btn === "autopush_edit_remove") {
                const feed_id = JSON.parse(localStorage.source_clicked)
                const result = await http.patch('api/feed/' + feed_id, {rss: ''}, {headers: {authorization: getJwt()}});

                const feedData = await result.data;

                this.updateSources(feedData)
                if (result && result.status === 200) {
                    toastr.success('You successfully removed workspace source ' + result.data.name);
                } else {
                    toastr.info(result);
                }
            } else if (btn === "delete_team_btn") {
                // console.log("acceptModal this.state.feed_in_team ", this.state.feed_in_team, "this.state.admin_id", this.state.admin_id);
                // alert(btn);
                //console.log('APP JS delete team data');
                //add admins to specific feed in team
                //console.log("acceptModal delete_team_btn ", btn);
                // console.log("acceptModal this.state.feed_in_team", this.state.feed_in_team);
                if (this.state.feed_in_team) {
                    let admin_id = data.admin_id;

                    //{{url_api}}/api/user/1/feed/576/admin/105
                    //const result = await http.delete('api/user/'+getCurrentUserId()+'/team-feed/'+data.team_id + admin_id, {headers: {authorization: getJwt()}});

                    if (this.state.pending_admin) {
                        if (admin_id) {
                            admin_id = '/pending_admin/' + data.admin_id;
                        }
                        const result = await http.delete('api/user/' + getCurrentUserId() + '/feed/' + data.team_id + admin_id, {headers: {authorization: getJwt()}});
                        // const result = await http.delete('api/team-feed/' + data.team_id + admin_id, {headers: {authorization: getJwt()}});
                        if (result) {
                            const result_data = result.data;
                            // console.log("PENDING acceptModal data", result_data);
                            if (result_data.message.includes("Successfully")) {
                                this.setState({
                                    teams: result_data.teams.data, teams_in: result_data.teams_in.data
                                });
                            }
                        }
                    } else {
                        // console.log(data);
                        if (admin_id) {
                            admin_id = '/admin/' + data.admin_id;
                        }
                        // alert(admin_id);
                        // console.log("btn === delete_team_btn - admin_id", admin_id);
                        if (admin_id) {
                            const result = await http.delete('api/user/' + getCurrentUserId() + '/feed/' + data.team_id + admin_id, {headers: {authorization: getJwt()}});
                            // const result = await http.delete('api/team-feed/' + data.team_id + admin_id, {headers: {authorization: getJwt()}});
                            if (result) {
                                const result_data = result.data;
                                // console.log("acceptModal data", result_data);
                                if (result_data.message.includes("Successfully")) {
                                    this.setState({
                                        teams: result_data.teams.data, teams_in: result_data.teams_in.data
                                    });
                                }
                            }
                        } else {
                            let feed_id = +data.team_id || "";
                        }

                    }
                    this.setState({
                        feed_in_team: false, admin_id: "", pending_admin: false
                    });
                    // alert(btn);

                } else if (this.state.admin_id) {
                    // console.log("acceptModal data", data);
                    // console.log("acceptModal this.state.admin_id", this.state.admin_id);
                    // alert("this.state.admin_id");
                    if (this.state.pending_admin) {
                        const result = await http.delete('api/user/' + getCurrentUserId() + '/team/' + data.team_id + '/pending_admin/' + data.admin_id, {headers: {authorization: getJwt()}});
                        if (result) {
                            const result_data = result.data;
                            // console.log("acceptModal data", result_data);
                            if (result_data.message.includes("Successfully")) {
                                this.setState({
                                    teams: result_data.teams.data, teams_in: result_data.teams_in.data
                                });
                            }
                        }
                        this.setState({
                            pending_admin: false
                        });
                    } else {

                        // else
                        // {
                        // console.log("acceptModal data", data);
                        // console.log("acceptModal this.state.admin_id", this.state.admin_id);
                        // alert("data.team_name", data.team_name);
                        const result = await http.delete('api/user/' + getCurrentUserId() + '/team/' + data.team_id + '/admin/' + data.admin_id, {headers: {authorization: getJwt()}});
                        if (result) {
                            const result_data = result.data;
                            // console.log("acceptModal data", result_data);
                            if (result_data.message.includes("Successfully")) {
                                this.setState({
                                    teams: result_data.teams.data, teams_in: result_data.teams_in.data
                                });
                            }
                        }
                        // }
                        //{{url_api}}/api/user/1/team/544/admin/105

                    }
                    //const result = await http.delete('api/user/'+getCurrentUserId()+'/team/'+data.team_id +'/admin/'+data.admin_id, {headers: {authorization: getJwt()}});
                    this.setState({
                        admin_id: ""
                    })
                } else {
                    const result = await http.delete('api/user/' + getCurrentUserId() + '/team/' + data.team_id, {headers: {authorization: getJwt()}});
                    if (result) {
                        const result_data = result.data;
                        // console.log("acceptModal data", result_data);
                        if (result_data.message.includes("Successfully")) {
                            this.setState({
                                teams: result_data.teams.data, teams_in: result_data.teams_in.data
                            });
                        }
                    }

                }

            } else if (btn === "submit_contact_support") {

            } else {
                //console.log("acceptModal btn ELSE",  btn);
                //console.log("acceptModal data", data);
                const result = await http.patch('api/user/' + user_id + '/password', data, {headers: {authorization: getJwt()}});
                //console.log("acceptModal password result", result);
                if (result && result.status === 200) {
                    toastr.success(result.data.message);
                } else {
                    toastr.info(result);
                }
            }
        } catch (ex) {
            this.setState({mounted: false});
            if (btn === "delete_team_btn") {
                toastr.error('Reassign or delete all workspaces associated ' + 'with this team before trying to delete the entire team.');

            } else {

                if (ex.response && ex.response.status === 404) toastr.error("Something went wrong... Please refresh and try again.");
                if (ex.response && ex.response.status === 401) {
                    //let errors = { ...this.state.errors }
                    //console.log(ex.response.data);
                    toastr.error(ex.response.data.message);
                    //window.location = "/";
                    this.props.history.push('/logout');
                }
                if (ex.response && ex.response.status === 400) {

                    toastr.error(ex);
                }
            }
        }
    };

    addSource = (e) => {
        this.props.history.push('/workspace-name');
        // ReactGA.event({
        //     category: 'Click',
        //     action: '+ New Feed',
        //     label: '',
        //     nonInteraction: true
        // });
    };

    selectFeed = async (id) => {
        this.setState({
            feed_id: id
        })
    }

    activateFeed = async (e) => {
        const feed_id = e.target.id || "";
        const feed_method = e.target.name || "";
        const activate = feed_method === "activate";

        if (feed_id) {
            try {
                if (activate) {
                    //const result_get = await http.get('api/feed/' + feed_id + '/activate', {headers: {authorization: getJwt()}});
                    await http.get('api/feed/' + feed_id + '/activate', {headers: {authorization: getJwt()}});
                    //const data = result.data.data;
                    //console.log("Main activateFeed result_get", result_get);
                    this.setState({
                        source_active: true
                    });
                } else {
                    //const result_delete = await http.delete('api/feed/' + feed_id + '/activate', {headers: {authorization: getJwt()}});
                    await http.delete('api/feed/' + feed_id + '/activate', {headers: {authorization: getJwt()}});
                    //const data = result.data.data;
                    //console.log("Main activateFeed result_delete", result_delete);
                    this.setState({
                        source_active: false
                    });
                    $('.feed-dropdown').fadeToggle();
                }

            } catch (ex) {
                toastr.error(ex.response.data.message);
            }
        } else {
            toastr.error("Feed ID null.")
        }
    };

    deleteFeed = async (e, data = "") => {
        const feed_id = this.state.feed_id || "";
        //const feed_method = e.target.name || "";
        //const activate = feed_method === "activate";
        //console.log("console.log(ex.response.data);", data);
        if (feed_id && feed_id !== 22 && feed_id != 24) {
            try {
                //alert('api/feed/' + feed_id);
                //     const result_delete = await http.delete('api/feed/' + feed_id, {headers: {authorization: getJwt()}});
                let result_delete = await http.delete('api/feed/' + feed_id, {headers: {authorization: getJwt()}});
                //const data = result.data.data;
                // console.log("Main deleteFeed result_delete", result_delete);
                //this.setState({
                //    source_active: false
                //});
                $('.feed-dropdown').fadeToggle();

                //let platforms_enabled = [];
                if ((this.state.user.sources.data && this.state.user.sources.data.length)
                    //    || (this.state.user.feeds_shared && this.state.user.feeds_shared.length)
                ) {
                    let deleted_source_check = this.state.user && this.state.user.sources && this.state.user.sources.data && this.state.user.sources.data.length ? this.state.user.sources.data.filter(el => {
                        return (el.id.toString() !== feed_id.toString())
                    }) : []
                    // let deleted_feed_shared_check = this.state.user
                    // && this.state.user.feeds_shared && this.state.user.feeds_shared.length ?
                    //     this.state.user.feeds_shared.filter(el => {
                    //         return (el.project_id.toString() !== feed_id.toString())
                    //     })
                    //     :
                    //     []
                    // console.log('deleteFeed: ', deleted_source_check, deleted_feed_shared_check)
                    //console.log("Main deleteFeed result_delete deleted_source", deleted_source_check);
                    if (deleted_source_check.length
                        //    || deleted_feed_shared_check.length
                    ) {
                        this.setState({
                            user: Object.assign({}, this.state.user, {
                                sources: {
                                    data: [...deleted_source_check]
                                }, //  feeds_shared: [...deleted_feed_shared_check]
                            })
                        });
                        this.setState({
                            selected_source: deleted_source_check.length ? deleted_source_check[0].id
                                //: deleted_feed_shared_check.length ? deleted_feed_shared_check[0].project_id
                                : '', source_active: deleted_source_check.length ? deleted_source_check[0].active
                                //: deleted_feed_shared_check.length ? deleted_feed_shared_check[0].active
                                : false
                        });
                    } else {
                        this.setState({
                            user: Object.assign({}, this.state.user, {
                                sources: {
                                    data: []
                                }, //feeds_shared: []
                            })
                        });
                        this.setState({
                            selected_source: "", source_active: false
                        });
                    }
                    //platforms_enabled = selected_source_check[0].platforms_enabled;
                }
                toastr.success("Project deleted successfully!");
                this.closeModal();

            } catch (ex) {
                toastr.error("Project couldn't be deleted");
                this.closeModal();
            }
        } else {
            toastr.error("Project ID null.")
        }
    };

    openModalDeleteFeed = (e) => {
        // console.log("openModal e.target ",  e.target);
        let btn = e.target.name;
        const feed_id = e.target.id || "";
        if (btn === "delete") {
            this.setState({
                visible_delete_feed_modal: true, feed_id: feed_id
            })
        }
    };

    enablePlatform = async (e) => {
        // console.log("enablePlatform enablePlatform e.target", e.target);
        const feed = e.target.title;
        const platform = e.target.id;
        // console.log('platform in app.js: ', platform)
        try {
            this.setState({
                wp_spinner: true
            });
            const resultEnable = await http.get('api/feed/' + feed + '/platform/' + platform, {headers: {authorization: getJwt()}});
            // console.log("Main enablePlatform resultEnable", resultEnable);
            // console.log('resultEnable u app.js: ', resultEnable)
            if (resultEnable.data.data) {
                let selected_source_check = resultEnable.data.data;
                this.setState({
                    platforms_enabled: selected_source_check.platforms_enabled || []
                });

            } else {
                this.setState({
                    platforms_enabled: []
                });
            }
        } catch (ex) {
            if (ex.response && ex.response.status === 404) toastr.error("Something went wrong... Please refresh and try again.");
            if (ex.response && ex.response.status === 401) {
                toastr.error(ex.response.data.message);
                this.props.history.push('/logout');
            }
            this.setState({
                platforms_enabled: []
            });
        }
    };

    addCard = (e) => {
        const go_to = e.target.id;
        this.props.history.push(go_to);
    };

    checkAllPagesAndChannels = (e) => {
        const {checked_send_all} = this.state;

        this.setState({
            checked_send_all: !checked_send_all
        })
    };

    checkPagesAndChannels = (e) => {
        if (e.target.id === "web_push") {
            const name_id = e.target.id;
            this.setState({
                checked_channels: Object.assign({}, this.state.checked_channels, {[name_id]: !this.state.checked_channels[name_id]})
            });
        } else if (e.target.id === "all") {
        } else if (e.target.name === "check_admins_team") {
            const id = e.target.id;
            const name = e.target.name;
            const checked_sources = this.state.checked_sources;
            let source_filtered = checked_sources.filter(src => (src.id.toString() === id.toString()))[0];

            source_filtered.checked = !source_filtered.checked;
            let sources_filtered = checked_sources.filter(src => (src.id.toString() !== id.toString()));

            this.setState({
                checked_sources: [...sources_filtered, source_filtered]
            });
        } else {
            const id = e.target.id;

            const facebook_pages = this.state.checked_channels.facebook;

            let page_filtered = facebook_pages.filter(page => (page.page === id))[0];

            if (page_filtered) {
                page_filtered.checked = !page_filtered.checked;
            }

            let pages_filtered = facebook_pages.filter(page => (page.page !== id));

            this.setState({
                checked_channels: Object.assign({}, this.state.checked_channels, {
                    facebook: [...pages_filtered, page_filtered]
                })
            });
        }
    };

    onClickHam = () => {
        //console.log("onClickHam", $(window).width());

        if ($(window).width() < 1024) {
            $('body').toggleClass('overflow-hidden');
            $('.side-menu').toggleClass('open-menu');

            if ($('.side-menu').hasClass('open-menu')) {

                $('.dashboard-menu').fadeIn();
                $('.footer-menu').fadeIn();
                $('.dash-logo-img').fadeIn();
                $('.header-right-side').fadeOut();
                $('#top-header').removeClass('active')
            } else {

                $('.dashboard-menu').fadeOut();
                $('.footer-menu').fadeOut();
                $('.dash-logo-img').fadeOut();
                $('.header-right-side').fadeIn();
                $('#top-header').addClass('active')
            }
            $('#ham').toggleClass('active');
            //$('.selectForHam').fadeToggle();
            if ($('.dashboard-menu').css('display') === 'block') {
                $('.inactive-banner').fadeToggle();
            }
        }
    };

    //switching
    onSourceSwitch = async ({target}) => {
        //console.log('On source switch: ', target.innerText)
        localStorage.setItem('workspaceName', target.innerText);
        let platforms_enabled = [];
        let selected_source_data = '';
        // console.log('User in onSourceSwitch: ', this.state.user)
        if ((this.state.user.sources.data && this.state.user.sources.data.length > 0)
            //    || (this.state.user.feeds_shared && this.state.user.feeds_shared.length > 0)
        ) {

            let selected_source_check = this.state.user.sources.data.filter(el => {
                if (el.id.toString() === target.id.toString()) {
                    selected_source_data = el;
                }
                return (el.id.toString() === target.id.toString())
            });
            if (selected_source_check.length) {
                platforms_enabled = selected_source_check[0].platforms_enabled;
            }
            // else if (this.state.user.feeds_shared && this.state.user.feeds_shared.length > 0) {
            //     let selected_feed_shared = this.state.user.feeds_shared.filter(el => {
            //         if (el.project_id.toString() === target.id.toString()) {
            //             selected_source_data = el;
            //         }
            //         return (el.project_id.toString() === target.id.toString())
            //     });
            //     if (selected_feed_shared.length) {
            //         platforms_enabled = selected_feed_shared[0].platforms_enabled;
            //     }
            // }
        }
        // console.log('Platforms enabled in onSourceSwitch: ', platforms_enabled)

        let selected_source_rss = "";
        let source_active = target.title === 'active';
        if (typeof (target.name) === 'undefined') {
            selected_source_rss = target.attributes[2].value || "";
        } else {
            selected_source_rss = target.name;
        }

        this.setState({
            selected_source: target.id,
            selected_source_rss: selected_source_rss,
            selected_source_data,
            source_active: source_active,
            platforms_enabled: platforms_enabled, //platforms_enabled: this.state.user.sources.length>0 && this.state.user.sources[0].platforms_enabled ? this.state.user.sources[0].platforms_enabled : []
        });
        this.setState({
            editing: false, checked_send_all: false
        });

        localStorage.setItem("source_clicked", JSON.stringify(target.id.toString()));
        // localStorage.setItem("feed_id", JSON.stringify(target.id.toString()));

        let pages_filtered = this.state.checked_channels.facebook;

        for (let i_check = 0; i_check < pages_filtered.length; i_check++) {
            pages_filtered[i_check].checked = false;
        }

        this.setState({
            checked_channels: Object.assign({}, this.state.checked_channels, {
                facebook: [...pages_filtered], web_push: false, slack: false, twitter: false, linkedin: false
            },)
        });
        await this.handleGetTags();
        await this.checkIfProjectPlanSelected();
    };

    selectSource = (data) => {
        // console.log('selectSource: ', data)
        this.setState({
            selected_source: data.id,
            selected_source_rss: data.selected_source_rss,
            selected_source_data: data,
            source_active: data.source_active,
        });
    }

    updateSources = (selected_src_info) => {
        // console.log('selected_src_info: ', selected_src_info, this.state.user.sources.data)
        const sources = this.state.user.sources.data;
        //const feeds_shared = this.state.user.feeds_shared;
        const index = sources.findIndex((src) => src.id === selected_src_info.id);
        //const index2 = feeds_shared.findIndex((src2) => src2.project_id === selected_src_info.id)

        // const updated_sources = update(this.state.user.sources.data, {$splice: [[index, 1, selected_src_info]]});  // array.splice(start, deleteCount, item1)
        const updated_sources = index === -1
            //&& index2 === -1
            ? [selected_src_info, ...sources] : sources
        if (index !== -1
            //    || index2 !== -1
        ) {
            updated_sources[index] = selected_src_info;
        }
        //const updated_feeds_shared = index2 !== -1 ? feeds_shared[index2] = selected_src_info : feeds_shared

        this.setState({
            user: Object.assign({}, this.state.user, {
                sources: {
                    data: updated_sources
                },
            })
        });

        this.checkIfProjectPlanSelected();
    };

    updateUser = (selected_user_info) => {
        //console.log('updateUser function: ', selected_user_info);
        this.setState({
            user: Object.assign({}, this.state.user, selected_user_info)
        });
    };

    validateRss = async (selected_src_info) => {
        try {
            toastr.info("Checking if rss link is valid... Please wait.");
            //const url = "https://boingboing.net/feed";
            const data = {
                url: selected_src_info.rss
            };
            const result = await http.post('api/check_rss', data, {headers: {authorization: getJwt()}});
            if (result.data) {
                const rss_valid = result.data.rss_valid;
                //let res = await axios.get('https://boingboing.net/feed', function(data) {
                //console.log("result.data  ", result.data);
                if (rss_valid) {
                    toastr.success("RSS FEED VALID!");
                    //this.setState({rss_manually: "none"});
                    //if(name === "valid_and_continue")
                    //{
                    //    this.doSubmit();
                    //}
                } else {
                    toastr.error("RSS FEED NOT VALID!");
                }
                this.setState({rss_valid});
            } else {
                this.setState({rss_valid: false});
            }


        } catch (ex) {
            toastr.error("Error fetching workspace data. " + ex);
            this.setState({rss_valid: false});
        }

    };

    updatePhoto = (selected_photo) => {
        this.setState({
            user: Object.assign({}, this.state.user, {
                profile_photo: selected_photo
            })
        });
    };

    toggleFeedInfo = async (selected_src_info) => {

        if (this.state.editing) {
            if (selected_src_info !== "cancel") {
                const schema = {
                    website: Joi.string().uri(), rss: Joi.string().uri()
                };
                const {error} = Joi.validate({
                    rss: selected_src_info.rss, website: selected_src_info.website
                }, schema);
                const call_api = error ? error.details[0].message : null;
                //console.log("errorerrorerrorerrorerror",error);
                if (!call_api) {
                    this.validateRss(selected_src_info);
                    this.updateSources(selected_src_info);
                    const url_patch_feed = '/api/user/' + getCurrentUserId() + '/feed';
                    let feed_data = {...selected_src_info, feed_id: selected_src_info.id || ""};
                    const headers_def = {authorization: getJwt()};
                    await http.patch(url_patch_feed, feed_data, {headers: headers_def});
                    //console.log("Main toggleFeedInfo res ", res);
                    //const data = res.data.data;
                } else {
                    //console.log("ELSE errorerrorerrorerrorerror error.length",error);
                    //console.log("ELSE errorerrorerrorerrorerror error.details[0].message",error.details[0].message);
                    toastr.error("Error validating filelds. " + error);
                }

            }

        }

        this.setState({editing: !this.state.editing})
    };


    //
    createNewTag = () => {

    }


    componentDidMount = async () => {
        if (process.env.REACT_APP_ENVIRONMENT === 'PROD') {
            // console.log('initialize GA')
            ReactGA.initialize('UA-90436832-5', {
                debug: false, titleCase: false
            })
        }

        toastr.options = {
            closeButton: true,
            positionClass: "toast-bottom-full-width",
            showDuration: "300",
            hideDuration: "1000",
            timeOut: "8000",
            extendedTimeOut: "1000",
        };
        const advancedMatching = {em: 'some@email.com'}; // optional, more info: https://developers.facebook.com/docs/facebook-pixel/advanced/advanced-matching
        const options = {
            autoConfig: true, // set pixel's autoConfig
            debug: false, // enable logs
        };
        if (process.env.REACT_APP_ENVIRONMENT === 'PROD') {
            ReactPixel.init('498191097777146', advancedMatching, options);
        }
        try {
            const user_id = await getCurrentUserId();
            if (!user_id && (window.location.pathname !== "/login") && (window.location.pathname !== "/register") && (window.location.pathname !== "/register/") && (window.location.pathname !== "/checkout") && (window.location.pathname !== "/martech-ltd-success") && (window.location.pathname !== "/maintenance")) {
                window.location = "/login";
                // console.log('userID: ', user_id)

            } else if (user_id) {
                // const result = await http.get('api/user/' + user_id, {headers: {authorization: getJwt()}});
                let result;
                try {
                    result = await http.get('api/user_info', {headers: {authorization: getJwt()}});
                } catch (e) {
                    //console.log('CDM user_info error : ', e)
                    window.location = "/logout";
                    se
                }
                const data = await result.data.data;
                const user = await data;

                if ((user.active === 0) && (window.location.pathname !== "/email-verification")) {
                    window.location = await "/email-verification";
                } else if ((user.active === 1) && (user.name === " ") && (window.location.pathname !== "/insert-name")) {
                    window.location = await "/insert-name";
                } else if ((user.active === 1) && (user.name !== " ") && !user.phone && (window.location.pathname !== '/insert-phone')) {
                    window.location = await "/insert-phone";
                } else if ((user.active === 1) && (user.name !== " ") && user.phone && (user.phone_validated !== 1) && (window.location.pathname !== '/insert-phone') && (window.location.pathname !== '/phone-validation')) {
                    window.location = await "/phone-validation";
                }

                // console.log("data", user);

                this.setState({user: user});
                // this.props.appPropagateUserData(user);

                let selected_source = await localStorage.source_clicked && localStorage.source_clicked.toString() !== "undefined" ? JSON.parse(localStorage.source_clicked) : user.sources.data && user.sources.data.length > 0 ? user.sources.data[user.sources.data.length - 1].id : // user.feeds_shared && user.feeds_shared.length > 0 ?
                    // user.feeds_shared[user.feeds_shared.length - 1].project_id
                    // :
                    "";
                let selected_source_check = [selected_source];
                let selected_source_data = '';

                if (!localStorage.source_clicked && selected_source) {
                    localStorage.setItem("source_clicked", JSON.stringify(selected_source.toString()));
                }

                if (user.sources.data && user.sources.data.length > 0) {
                    selected_source_check = user.sources.data.filter(el => {
                        if (el.id.toString() === selected_source.toString()) {
                            this.setState({selected_source_data: el});
                        }

                        return (el.id.toString() === selected_source.toString())
                    });
                }

                // if (selected_source_check.length === 0) {
                //     if (user.feeds_shared && user.feeds_shared.length > 0) {
                //         selected_source_check = user.feeds_shared.filter(el => {
                //             if (el.project_id.toString() === selected_source.toString()) {
                //                 this.setState({selected_source_data: el});
                //             }
                //
                //             // return (el.id.toString() === selected_source.toString())
                //         });
                //     } else {
                //         if (user.sources.data.length) {
                //             selected_source = user.sources.data[0].id
                //         } else if (user.feeds_shared.length) {
                //             selected_source = user.feeds_shared[0].project_id
                //         }
                //     }
                //     //console.log("selected_source_check","selected source doesn't exist ", selected_source);
                // }
                //console.log('APP.JS selected_source: ', selected_source)

                await this.setState({
                    selected_source: selected_source,
                    platforms_enabled: selected_source_check.length > 0 && selected_source_check[0].platforms_enabled ? selected_source_check[0].platforms_enabled : []
                });

                // console.log("selected_sourceselected_sourceselected_sourceselected_sourceselected_source", this.state.selected_source);
                if (user.sources.data) {
                    let filteredRSS = "";
                    let filteredActive = false;
                    let filtered = {};
                    if (user.sources.data.length > 0) {
                        filtered = user.sources.data.filter(item => (item.id.toString() === selected_source.toString()))[0];
                        //console.log("filtered", filtered);
                        //console.log("typeof(filtered) === 'undefined'", typeof(filtered) === 'undefined');
                        //console.log("AAAAAAAAAAAA selected_source_check length", selected_source_check.length);
                        if (typeof (filtered) === 'undefined' && selected_source_check.length > 0) {
                            filtered = selected_source_check[0];
                            //console.log("filteredfilteredfiltered", filtered);

                        }
                        filteredRSS = filtered ? filtered.rss : "";
                        filteredActive = filtered ? filtered.active ? true : false : false;
                        // console.log("filteredActive", filteredActive);
                        //console.log("filteredRSS", filteredRSS);
                    }

                    if (filtered) {
                        // console.log('Source in app.js: ', filtered, selected_source, filteredActive)
                        this.setState({
                            selected_source_rss: filteredRSS ? filteredRSS : "",
                            rss_valid: filteredRSS ? true : false,
                            source_active: filteredActive
                        });
                    }

                    let sources_checked = user.sources.data.map(src => {
                        return {id: src.id, name: src.name, checked: true}
                    });


                    this.setState({checked_sources: sources_checked});

                }


                let fb_pgs_checked = data.facebook_pages.data.map(page => {
                    return {page: page.fb_page_id, checked: true, feed_id: page.feed_id}
                });

                let fb_pgs_checked_shared = user.facebook_pages_shared.map(page => {
                    return {page: page.page_id, checked: true, feed_id: page.project_id}
                });

                fb_pgs_checked = [...fb_pgs_checked, ...fb_pgs_checked_shared];
                // console.log("componentDidMount fb_pgs_checked_shared ", fb_pgs_checked, fb_pgs_checked_shared);

                this.setState({
                    checked_channels: Object.assign({}, this.state.checked_channels, {
                        facebook: fb_pgs_checked
                    })
                });


                if (!data) {
                    toastr.error("User id does not match. :(  Please log in again.");
                    this.props.history.push('/logout');
                } else {
                    //let set_browser_src = localStorage.source_clicked ? JSON.parse(localStorage.source_clicked) : "";
                    //if(set_browser_src)
                    //{
                    //    let source_to_set = user.sources.data.filter(src => (src.id.toString() === set_browser_src.toString()))[0];
                    //}
                    setCurrentUserName(data.name);
                }
            }
            // else {
            //     if (window.location.pathname !== "/login" && window.location.pathname !== "/register") {
            //         window.location = "/login";
            //     }
            // }
            if (this.state.user.name && this.state.user.id && this.state.selected_source && getJwt() && this.state.user.sources.data.length > 0) {
                // console.log('sending tag req');
                let tagsResponse = await http.get('api/user/' + this.state.user.id + '/source/' + this.state.selected_source + '/tags', {headers: {authorization: getJwt()}});

                // console.log('tags response: ', tagsResponse);
                let tagsPageSize = await tagsResponse.data.data.length;

                //tags names only
                let tagsOnlyNames = [];
                if (tagsResponse && tagsResponse.data.data && tagsResponse.data.data.length) {
                    await tagsResponse.data.data.map(tag => {
                        // console.log('handling tag name:', tag['tag']);
                        tagsOnlyNames = [...tagsOnlyNames, tag['tag']];
                        // console.log('tagsOnlyNames:', tagsOnlyNames);
                    })
                }
                if (tagsPageSize) {
                    await this.setState({
                        tags: tagsResponse.data.data, filteredTags: tagsResponse.data.data, tagsPageSize, tagsOnlyNames
                    })
                }
            }

        } catch (ex) {
            if (ex.response && ex.response.status === 404) toastr.error("Something went wrong... Please refresh and try again.");
            if (ex.response && ex.response.status === 401) {
                toastr.error(ex.response.data.message);
                // this.props.history.push('/logout');
            }
        }

        if ((this.state.selected_source_data && this.state.selected_source_data.name === 'Greska') && (window.location.pathname !== "/billing/payment-methods") && (window.location.pathname !== "/billing/invoices") && (window.location.pathname !== "/billing/subscriptions") && (window.location.pathname !== "/workspace-name") && (window.location.pathname !== "/choose-team") && (window.location.pathname !== "/create-team") && (window.location.pathname !== "/subscription-plans") && (window.location.pathname !== "/existing-payment") && (window.location.pathname !== "/addfunds") && (window.location.pathname !== "/existing-payment")) {
            window.location = "/billing/payment-methods";
        }

        if (window.location.pathname !== "/subscription-plans") {
            await this.checkIfProjectPlanSelected()
        }
        if (getJwt()) {
            try {
                let result = ''


                result = await http.get('api/emitto_plans/product/emitto_plans', {headers: {authorization: getJwt()}});
                //console.log('plans data: ', result.data.data)
                this.setState({plansData: result.data.data})
            } catch (e) {
                toastr.error(e)
            }
        }
    }

    componentDidCatch(error, errorInfo) {
        // console.log('errorInfo: ', errorInfo)
    }

    checkIfProjectPlanSelected = async () => {
        try {
            const selectedSourceId = await localStorage.source_clicked && localStorage.source_clicked.toString() !== "undefined" ? JSON.parse(localStorage.source_clicked) : '';
            const selectedProject = await this.state.user.sources.data.find(project => project.id.toString() === selectedSourceId.toString());
            // console.log('checkIfProjectPlanSelected: ', selectedSourceId, this.state.user.sources.data, selectedProject)
            if (this.state.user.active === 1 && this.state.user.name !== " " && selectedProject && !selectedProject.platforms[0].plan && (window.location.pathname !== "/subscription-plans-promo")) {
                window.location = "/subscription-plans";
            }
        } catch (e) {
            //console.log('checkIfProjectPlanSelected ', e)
        }
    }

    handleGetTags = async () => {
        // console.log('handle get tags')
        await this.setState({
            tags: [], filterTags: [], tagsLoading: true
        });
        // console.log('handle tags called');
        try {
            let tagsResponse = await http.get('api/user/' + this.state.user.id + '/source/' + this.state.selected_source + '/tags', {headers: {authorization: getJwt()}});

            // console.log('tags response: ', tagsResponse.data.data);
            let tagsPageSize = tagsResponse.data.data.length;
            await this.setState({tags: tagsResponse.data.data, filteredTags: tagsResponse.data.data, tagsPageSize})
        } catch (ex) {
            if (ex.response && ex.response.status === 404) toastr.error("Something went wrong... Please refresh and try again.");
            if (ex.response && ex.response.status === 401) {
                toastr.error(ex.response.data.message);
                this.props.history.push('/logout');
            }
        }
        this.setState({tagsLoading: false})
    };
    handleCreateTag = async (newTag) => {

        let tagExists = this.state.tags.filter(tag => tag.tag === newTag);
        if (tagExists.length > 0) {
            toastr.error('This tag already exists! Please choose a different tag name.');
        } else {

            try {
                //     console.log('net tag name:', data.new_tag)
                let tags = await http.post('api/user/' + this.state.user.id + '/source/' + this.state.selected_source + '/tag', {tag: newTag}, {headers: {authorization: getJwt()}});
                tags = tags.data.data;
                // console.log('new tags:', tags);
                await this.setState({tags, filteredTags: tags, tagsPageSize: tags.length})
            } catch (ex) {
                if (this.state.user.sources.data.length !== 0) {
                    if (ex.response && ex.response.status === 404) toastr.error("Something went wrong... Please refresh and try again.");
                    if (ex.response && ex.response.status === 401) {
                        toastr.error(ex.response.data.message);
                        this.props.history.push('/logout');
                    }
                }
            }
        }
    };

    handleTagsSearch = (e) => {
        //console.log('tags search target: ', e.target.value);
        // let filteredTags = this.state.tags.filter(tag => tag.tagName.includes(e.target.value));
        // console.log('filteredTags:', filteredTags);
        const filtered = this.state.tags.filter(tag => tag.tag.toLowerCase().includes(e.target.value.toLowerCase()));
        //console.log('filtered tags:', filtered);
        this.setState({
            filteredTags: filtered, tagsPageSize: filtered.length
        })
    };


    componentDidUpdate = () => {
        //if(this.props.user !== nextProps.user)
        // if (this.state.user !== nextProps.user) {
        // this.setState({user: nextProps.user});
        let fb_pgs_checked = this.state.user.facebook_pages.data.map(page => {
            // console.log('Ovo je page: ', page)
            // console.log('Ovo je iz checked_channel.facebook: ',  this.state.checked_channels.facebook)
            const checkedChannel = this.state.checked_channels.facebook.find(channel => channel.page === page.fb_page_id)
            return {
                page: page.fb_page_id,
                checked: checkedChannel ? checkedChannel.checked : false,
                feed_id: page.feed_id,
                connected: page.page_connected
            }
        });


        let fb_pgs_checked_shared = this.state.user.facebook_pages_shared.map(page => {
            const checkedSharedChannel = this.state.checked_channels.facebook.find(channel => channel.page === page.fb_page_id)
            return {
                page: page.page_id,
                checked: checkedSharedChannel ? checkedSharedChannel.checked : false,
                feed_id: page.project_id,
                connected: page.connected ? 'Connected' : 'Not Connected'
            }
        });

        fb_pgs_checked = [...fb_pgs_checked, ...fb_pgs_checked_shared];

        if (JSON.stringify(fb_pgs_checked) !== JSON.stringify(this.state.checked_channels.facebook)) {
            this.setState({
                checked_channels: Object.assign({}, this.state.checked_channels, {
                    facebook: fb_pgs_checked
                })
            });
        }

        if (!this.state.selected_source) {

            const user = this.state.user;

            let selected_source = localStorage.source_clicked && localStorage.source_clicked.toString() !== "undefined" ? JSON.parse(localStorage.source_clicked) : user.sources.data && user.sources.data.length > 0 ? user.sources.data[user.sources.data.length - 1].id : // user.feeds_shared && user.feeds_shared.length > 0 ?
                //     user.feeds_shared[user.feeds_shared.length - 1].project_id :
                "";

            if (selected_source && !this.state.selected_source) {
                this.setState({selected_source})
            }

            if (!selected_source) {
                if (user.sources.data.length) {
                    selected_source = user.sources.data[0].id
                    this.setState({
                        selected_source: selected_source
                    });
                    localStorage.setItem("source_clicked", JSON.stringify(selected_source.toString()));
                    // console.log('Opalio je ovaj u compDidUpdate 1: ', selected_source, user)
                }
                // else if (user.feeds_shared.length) {
                //     selected_source = user.feeds_shared[0].project_id
                //     this.setState({
                //         selected_source: selected_source
                //     });
                //     // console.log('Opalio je ovaj u compDidUpdate 2: ', selected_source, user)
                // }
                // console.log('Opalio je ovaj u compDidUpdate: ', selected_source, user)
            }

        }

        if ((this.state.selected_source_data && this.state.selected_source_data.name === 'Greska') && (window.location.pathname !== "/billing/payment-methods") && (window.location.pathname !== "/billing/invoices") && (window.location.pathname !== "/billing/subscriptions") && (window.location.pathname !== "/workspace-name") && (window.location.pathname !== "/choose-team") && (window.location.pathname !== "/create-team") && (window.location.pathname !== "/subscription-plans") && (window.location.pathname !== "/existing-payment") && (window.location.pathname !== "/add-funds") && (window.location.pathname !== "/add-funds/billing-details") && (window.location.pathname !== "/add-funds/payment")) {
            window.location = "/billing/payment-methods";
        }

    }


    updateUserFromServer = async () => {
        console.info('entered updateUserFromServer')
        try {
            const user_id = await getCurrentUserId();
            if (user_id) {
                // const result = await http.get('api/user/' + user_id, {headers: {authorization: getJwt()}});
                let result
                try {
                    result = await http.get('api/user_info', {headers: {authorization: getJwt()}});
                } catch (e) {
                    //console.log('APP.js - updateUserFromServer error : ', e)
                    toastr.error(e)
                }

                const data = await result.data.data;
                let user = await data;


                let selected_source_data = '';
                user.sources.data.map(el => {
                    if (el.id.toString() === this.state.selected_source.toString()) {
                        selected_source_data = el;
                    }
                });

                await this.setState({
                    user: user, selected_source_data
                });
                // console.log('User was updated: ', user)
            }
        } catch (e) {
            toastr.error("Getting User's data from server was unsuccessfull")
        }

    }

    setDeleteSubscribersIndicator = async (indicator) => {
        await this.setState({deleteSubscribersIndicator: indicator});
    }

    isodateToDate = (date, type) => {
        // const localDate = dateObj.toLocaleDateString();

        // console.log('dateObj: ', dateObj, localDateTime)
        if (this.state.user.locals) {
            let dateFormat = this.state.user.locals.date_format
            let timeFormat = this.state.user.locals.time_format
            // let offset = parseInt(this.state.user.locals.offset)
            let zone = this.state.user.locals.timezone;

            // var isoDateTime = new Date(“2015-10-05T08:30:00"); var localDateTime = isoDateTime. toLocaleDateString() + ” ” + isoDateTime. toLocaleTimeString();

            Date.prototype.addHours = function (h) {
                this.setHours(this.getHours() + h);
                return this;
            }

            const dateWithoutOffset = new Date(date);

            // MomentJs code is commented, not used any more

            // let dateTimeFormat = dateFormat + ' ' + (timeFormat === 'AM/PM' ? 'hh:mm A zz' : 'HH:mm  zz');


            // const dateTimeZone = momentTimezone.tz(dateWithoutOffset, zone).format(dateTimeFormat)
            // const dateZone = momentTimezone.tz(dateWithoutOffset, zone).format('MM-DD-YYYY')
            // const timeZone = momentTimezone.tz(dateWithoutOffset, zone).format(timeFormat === 'AM/PM' ? 'hh:mm A zz' : 'HH:mm zz')

            // console.log('dateTimeZone old: ', dateTimeZone)
            // console.log('dateZone old: ', dateZone)
            // console.log('timeZone old: ', timeZone)

            let newDateFormat = dateFormat === 'DD-MM-YYYY' ? 'd-M-yyyy' : dateFormat === 'MM-DD-YYYY' ? 'M-d-yyyy' : 'yyyy-M-d';
            let newTimeFormat = timeFormat === 'AM/PM' ? 'hh:mm a zzz' : 'HH:mm  zzz';
            let dateTimeFormatNew = newDateFormat + ' ' + newTimeFormat;
            const zonedDate = utcToZonedTime(dateWithoutOffset, zone);

            const dateTimeZone = format(zonedDate, dateTimeFormatNew, {timeZone: zone});
            const dateZone = format(zonedDate, 'M-d-yyyy', {timeZone: zone});
            const timeZone = format(zonedDate, newTimeFormat, {timeZone: zone})

            // console.log('zonedDate: ', zonedDate)
            // console.log('dateTimeZone: ', dateTimeZone2)
            // console.log('dateZone: ', dateZone2)
            // console.log('timeZone: ', timeZone2)


            if (type === 'time') {
                return timeZone
            } else if (type === 'date') {
                return dateZone
            } else {
                return dateTimeZone
            }
        } else {
            Date.prototype.addHours = function (h) {
                this.setHours(this.getHours() + h);
                return this;
            }

            const dateWithoutOffset = new Date(date);

            let dateTimeFormat = 'd-M-yyyy HH:mm  zzz';

            const zonedDate = utcToZonedTime(dateWithoutOffset, 'Europe/Belgrade')
            const dateTimeZone = format(zonedDate, dateTimeFormat);
            const dateZone = format(zonedDate, 'M-d-yyyy');
            const timeZone = format(zonedDate, 'HH:mm zz');

            // const dateTimeZone = momentTimezone.tz(dateWithoutOffset, 'Europe/Belgrade').format(dateTimeFormat)
            // const dateZone = momentTimezone.tz(dateWithoutOffset, 'Europe/Belgrade').format('MM-DD-YYYY')
            // const timeZone = momentTimezone.tz(dateWithoutOffset, 'Europe/Belgrade').format('HH:mm zz')

            if (type === 'time') {
                return timeZone
            } else if (type === 'date') {
                return dateZone
            } else {
                return dateTimeZone
            }
        }

    }

    render() {

        let modal_connect_bot_to_page = <ConnectBotToPageModal
            visible_modal={this.state.visible_connect_bot_to_page_modal}
            onClickAway={this.closeModal}
            toggleConnect={this.toggleConnect}
            page_name={this.state.target_page_to_connect.slot}
            sources={this.state.user.sources.data}
            //feeds_shared={this.state.user.feeds_shared}
            selectedSource={this.state.selected_source}/>;
        // let active = this.state.user;
        // if(!active && this.state.remove_activation_email_modal)
        // {
        //     active=true;
        // }

        let modal_connect_viber = <ConnectViberModal
            visible_modal={this.state.visible_connect_viber_modal}
            selectedSource={this.state.selected_source}
            sources={this.state.user.sources.data}
            acceptModal={this.acceptModal}
            onClickAway={this.closeModal}
            rss_feed={this.state.selected_source_rss}
        />
        return (<Offline
            onChange={({isOffline, isOnline}) => this.setState({isOnline})}
        >
            {({isOffline, isOnline}) => {
                return isOffline ? <NoInternetConnection/> : !this.state.user.id || !this.state.user.phone_validated ?
                    <Switch>
                        {/*<Route path="/maintenance" render={(props) => <Maintenance/>}/>*/}
                        {/*<Redirect to="/maintenance"/>*/}
                        <Redirect from="/maintenance" to="/logout"/>

                        <Route path="/login" component={Login}/>
                        <Route path="/logout" component={Logout}/>
                        <Route path="/register" component={Register}/>
                        <Route path="/email-verification"
                               render={(props) => <EmailVerification user={this.state.user}
                                                                     updateUser={this.updateUser} {...props}
                               />}/>
                        <Route path="/phone-validation"
                               render={(props) => <PhoneVerification user={this.state.user}
                                                                     updateUser={this.updateUser} {...props}
                                                                     updateUserFromServer={this.updateUserFromServer}
                               />}/>
                        <Route path="/forgot-password" component={ForgotPassword}/>
                        {/*<Route path="/reset-password" component={ResetPassword}/>*/}
                        <Route path="/recovery-sent" component={RecoverySent}/>
                        <Route path="/password-updated" component={PasswordUpdated}/>
                        <Route path='/insert-name'
                               render={(props) => <InsertName user={this.state.user}
                                                              updateUser={this.updateUser}
                                                              updateUserFromServer={this.updateUserFromServer}
                                                              {...props}
                               />}
                        />
                        <Route path='/insert-phone'
                               render={(props) => <InsertPhone user={this.state.user}
                                                               updateUser={this.updateUser}
                                                               updateUserFromServer={this.updateUserFromServer}
                                                               {...props}
                               />}
                        />
                        <Route path='/checkout' component={Checkout}/>
                        <Route path="/martech-ltd-success" component={CheckoutConfirmation}/>
                    </Switch> : <Sentry.ErrorBoundary
                        showDialog={false}
                        beforeCapture={(scope) => {
                            scope.setTag("userId", this.state.user && this.state.user.id ? this.state.user.id : '');
                            scope.setTag("workspaceId", this.state.selected_source || '');
                            // console.log('beforeCapture fired: ', this.state.user && this.state.user.id ? this.state.user.id : '', this.state.selected_source || '')
                        }}
                    >
                        <div>

                            {this.state.visible_connect_bot_to_page_modal ? modal_connect_bot_to_page : ""}
                            {this.state.visible_connect_viber_modal ? modal_connect_viber : ""}

                            {/*{(typeof(this.state.user.active) !== 'undefined') && !this.state.user.active ? modal_activation : ""}*/}


                            {/*{visible_delete_feed_modal ? modal_feed_delete : ""}*/}
                            <div
                                className={this.state.visible_web_push_instructions_modal || this.state.visible_connect_viber_modal ? "blur wrapper" : ""}
                            >
                                <Switch>
                                    {/*<Route path="/maintenance" render={(props) => <Maintenance/>}/>*/}
                                    {/*<Redirect to="/maintenance"/>*/}

                                    <Redirect from="/maintenance" to="/logout"/>

                                    <Route path="/login" component={Login}/>
                                    <Route path="/logout" component={Logout}/>
                                    <Route path="/register" component={Register}/>
                                    <Route path="/email-verification"
                                           render={(props) => <EmailVerification user={this.state.user}
                                                                                 updateUser={this.updateUser} {...props}
                                           />}/>
                                    <Route path="/phone-validation"
                                           render={(props) => <PhoneVerification user={this.state.user}
                                                                                 updateUser={this.updateUser}
                                                                                 updateUserFromServer={this.updateUserFromServer}
                                                                                 {...props}
                                           />}/>
                                    <Route path="/forgot-password" component={ForgotPassword}/>
                                    <Route path="/reset-password" component={ResetPassword}/>
                                    <Route path="/recovery-sent" component={RecoverySent}/>
                                    <Route path="/password-updated" component={PasswordUpdated}/>
                                    <Route path='/insert-name'
                                           render={(props) => <InsertName user={this.state.user}
                                                                          updateUser={this.updateUser}
                                                                          updateUserFromServer={this.updateUserFromServer}
                                                                          {...props}
                                           />}/>
                                    <Route path='/insert-phone'
                                           render={(props) => <InsertPhone user={this.state.user}
                                                                           updateUser={this.updateUser}
                                                                           updateUserFromServer={this.updateUserFromServer}
                                                                           {...props}
                                           />}
                                    />
                                    <Route path='/insert-company' render={(props) => <InsertCompany
                                        updateUserFromServer={this.updateUserFromServer}{...props}/>}/>
                                    <Route path='/create-team' component={CreateTeam}/>
                                    <Route path='/team-members' component={TeamMembers}/>

                                    {/*<Route path="/feed"*/}
                                    {/*       render={(props) => <Feed appPropagateUserData={this.appPropagateUserData}*/}
                                    {/*                                appPropagateUserPlatforms={this.appPropagateUserPlatforms}*/}
                                    {/*                                user={this.state.user}*/}
                                    {/*                                platforms_enabled={this.state.platforms_enabled}*/}
                                    {/*                                {...props}/>}/>*/}
                                    <Route path='/choose-team' render={(props) => <ChooseTeam
                                        user={this.state.user}
                                        selectSource={this.selectSource}
                                        updateUser={this.updateUser}
                                        appPropagateUserPlatforms={this.appPropagateUserPlatforms}
                                        {...props}/>}/>


                                    {/*{process.env.REACT_APP_ENVIRONMENT === 'DEV' ?*/}
                                    <Route path="/subscription-plans"
                                           render={(props) => <SubscriptionPlans
                                               user={this.state.user}
                                               selectedSource={this.state.selected_source}
                                               openModal={this.openModal}
                                               acceptModal={this.acceptModal}
                                               closeModal={this.closeModal}
                                               name={this.state.name}
                                               email={this.state.email}
                                               visible_modal={this.state.visible_contact_support_modal}
                                               plansData={this.state.plansData}
                                               updateUserFromServer={this.updateUserFromServer}
                                               selectedSourceNode={this.state.selected_source_data}
                                               {...props}
                                           />}
                                    />

                                    <Route path="/subscription-plans-promo"
                                           render={(props) => <SubscriptionPlans
                                               user={this.state.user}
                                               selectedSource={this.state.selected_source}
                                               openModal={this.openModal}
                                               acceptModal={this.acceptModal}
                                               closeModal={this.closeModal}
                                               name={this.state.name}
                                               email={this.state.email}
                                               visible_modal={this.state.visible_contact_support_modal}
                                               plansData={this.state.plansData}
                                               updateUserFromServer={this.updateUserFromServer}
                                               selectedSourceNode={this.state.selected_source_data}
                                               {...props}
                                           />}
                                    />

                                    {/*    :*/}
                                    {/*    <Route path="/subscription-plans"*/}
                                    {/*           render={(props) => <SubscriptionPlansBlackFriday*/}
                                    {/*               user={this.state.user}*/}
                                    {/*               selectedSource={this.state.selected_source}*/}
                                    {/*               openModal={this.openModal}*/}
                                    {/*               acceptModal={this.acceptModal}*/}
                                    {/*               closeModal={this.closeModal}*/}
                                    {/*               name={this.state.name}*/}
                                    {/*               email={this.state.email}*/}
                                    {/*               visible_modal={this.state.visible_contact_support_modal}*/}
                                    {/*               plansData={this.state.plansData}*/}
                                    {/*               updateUserFromServer={this.updateUserFromServer} {...props}/>}/>*/}
                                    {/*}*/}

                                    <Route path='/feed-name'>
                                        <Redirect to='/workspace-name'/>
                                    </Route>
                                    <Route path="/workspace-name"
                                           render={(props) => <FeedName
                                               user={this.state.user}
                                               selectSource={this.selectSource}
                                               updateUser={this.updateUser}
                                               appPropagateUserPlatforms={this.appPropagateUserPlatforms}
                                               updateUserFromServer={this.updateUserFromServer}
                                               {...props}/>}
                                    />

                                    <Route path="/feed-source"
                                           render={(props) => <FeedSource {...props}/>}/>
                                    <Route path="/rss-feed-source"
                                           render={(props) => <RssFeedSource
                                               updateUser={this.updateUser}
                                               updateSources={this.updateSources}
                                               {...props}/>}
                                    />
                                    <Route path="/manual-feed-source"
                                           render={(props) => <ManualFeedSource {...props}/>}/>
                                    {/*{ console.log('Sources in app.js: ', this.state.user.sources.data, this.state.platforms_enabled) }*/}
                                    <Route path="/distribution-platforms"
                                           render={(props) => <DistributionPlatforms
                                               user={this.state.user}
                                               selectedSource={localStorage.feed_id}
                                               sources={this.state.user.sources.data}
                                               updateSources={this.updateSources}
                                               //feeds_shared={this.state.user.feeds_shared}
                                               platforms_enabled={this.state.platforms_enabled}
                                               selectSource={this.selectSource}
                                               // onClick={onClick}
                                               user_facebook_pages={this.state.user.facebook_pages.data}
                                               facebook_pages_shared={this.facebook_pages_shared}
                                               openModal={this.openModal}
                                               appPropagateUserData={this.appPropagateUserData}
                                               appPropagateUserPlatforms={this.appPropagateUserPlatforms}
                                               enablePlatform={this.enablePlatform}
                                               wp_spinner={this.state.wp_spinner}
                                               updateUser={this.updateUser}
                                               activateFeed={this.activateFeed}
                                               resetPlatformsEnabled={this.resetPlatformsEnabled}
                                               {...props}/>}
                                    />

                                    <Route path="/not-found" render={(props) => <NotFound/>}/>
                                    <Route path="/privacy" component={PrivacyPolicy}/>
                                    <Route path="/instructions"
                                           render={(props) => <Instructions
                                               // sources={sources}
                                               // selectedSource={selected_source}
                                               {...props}/>}/>
                                    <Route path="/add-funds" render={(props) => <AddFunds
                                        appState={this.state}
                                        user={this.state.user}
                                        updateUserFromServer={this.updateUserFromServer}
                                        selectedSource={this.state.selected_source}
                                        {...props}/>}/>
                                    <Route path="/pay-phone-numbers" render={(props) => <AddFunds
                                        appState={this.state}
                                        user={this.state.user}
                                        updateUserFromServer={this.updateUserFromServer}
                                        selectedSource={this.state.selected_source}
                                        {...props}/>}/>
                                    <Route path="/top-up" render={(props) => <AddFunds
                                        appState={this.state}
                                        user={this.state.user}
                                        updateUserFromServer={this.updateUserFromServer}
                                        selectedSource={this.state.selected_source}
                                        selectedSourceNode={this.state.selected_source_data}
                                        {...props}/>}/>
                                    <Route path="/viber-subscription" render={(props) => <AddFunds
                                        appState={this.state}
                                        user={this.state.user}
                                        updateUserFromServer={this.updateUserFromServer}
                                        selectedSource={this.state.selected_source}
                                        selectedSourceNode={this.state.selected_source_data}
                                        {...props}/>}/>
                                    <Route path="/existing-payment" render={(props) => <ExistingPayment
                                        appState={this.state}
                                        user={this.state.user}
                                        updateUserFromServer={this.updateUserFromServer}
                                        selectedSource={this.state.selected_source}
                                        selectedSourceNode={this.state.selected_source_data}
                                        {...props}/>

                                    }/>
                                    <Route path="/pay-phone-numbers-existing-payment"
                                           render={(props) => <ExistingPayment
                                               appState={this.state}
                                               user={this.state.user}
                                               updateUserFromServer={this.updateUserFromServer}
                                               selectedSource={this.state.selected_source}
                                               selectedSourceNode={this.state.selected_source_data}
                                               {...props}/>

                                           }/>
                                    <Route path="/topup-existing-payment"
                                           render={(props) => <ExistingPayment
                                               appState={this.state}
                                               user={this.state.user}
                                               updateUserFromServer={this.updateUserFromServer}
                                               selectedSource={this.state.selected_source}
                                               selectedSourceNode={this.state.selected_source_data}
                                               topUpViber={true}
                                               {...props}/>

                                           }/>
                                    <Route path="/viber-subscription-existing-payment"
                                           render={(props) => <ExistingPayment
                                               appState={this.state}
                                               user={this.state.user}
                                               updateUserFromServer={this.updateUserFromServer}
                                               selectedSource={this.state.selected_source}
                                               selectedSourceNode={this.state.selected_source_data}
                                               topUpViber={true}
                                               {...props}/>

                                           }/>
                                    <Route path="/phone-numbers" render={(props) => <PhoneNumbers
                                        appState={this.state}
                                        user={this.state.user}
                                        updateUserFromServer={this.updateUserFromServer}
                                        selectedSource={this.state.selected_source}
                                        selectedSourceNode={this.state.selected_source_data}
                                        {...props}/>}/>
                                    <Route path="/cransten-test" render={(props) => <CranstenTest/>}/>

                                    <Route path="/free-confirmation"
                                           render={(props) => <SubscriptionConfirmation{...props}/>}/>

                                    <Route path="/tester-monthly-confirmation"
                                           render={(props) => <SubscriptionConfirmation{...props}/>}/>
                                    <Route path="/starter-monthly-confirmation"
                                           render={(props) => <SubscriptionConfirmation{...props}/>}/>
                                    <Route path="/essentials-monthly-confirmation"
                                           render={(props) => <SubscriptionConfirmation{...props}/>}/>
                                    <Route path="/boost-monthly-confirmation"
                                           render={(props) => <SubscriptionConfirmation{...props}/>}/>

                                    <Route path="/tester-yearly-confirmation"
                                           render={(props) => <SubscriptionConfirmation{...props}/>}/>

                                    <Route path="/starter-yearly-confirmation"
                                           render={(props) => <SubscriptionConfirmation{...props}/>}/>
                                    <Route path="/essentials-yearly-confirmation"
                                           render={(props) => <SubscriptionConfirmation{...props}/>}/>
                                    <Route path="/boost-yearly-confirmation"
                                           render={(props) => <SubscriptionConfirmation{...props}/>}/>
                                    <Route path="/subscription-confirmation"
                                           render={(props) => <SubscriptionConfirmation{...props}/>}/>

                                    <Route path='/checkout' component={Checkout}/>
                                    <Route path="/martech-ltd-success" component={CheckoutConfirmation}/>

                                    <Route path="/account-verification" render={(props) => <AccountVerification
                                        appState={this.state}
                                        user={this.state.user}
                                        updateUserFromServer={this.updateUserFromServer}
                                        selectedSource={this.state.selected_source}
                                        selectedSourceNode={this.state.selected_source_data}
                                        {...props}/>}/>
                                    {/*<Route path='/pricing' render={(props) => <Pricing*/}

                                    {/*    {...props}*/}
                                    {/*/>*/}
                                    {/*}/>*/}
                                    <Route path="/" render={(props) => <Main
                                        fbError={this.state.fbError}
                                        appPropagateUserData={this.appPropagateUserData}
                                        user={this.state.user}
                                        appState={this.state}
                                        toggleConnect={this.toggleConnect}
                                        closeModal={this.closeModal}
                                        closeModalActive={this.closeModalActive}
                                        acceptModal={this.acceptModal}
                                        addSource={this.addSource}
                                        activateFeed={this.activateFeed}
                                        deleteFeed={this.deleteFeed}
                                        openModalDeleteFeed={this.openModalDeleteFeed}
                                        enablePlatform={this.enablePlatform}
                                        addCard={this.addCard}
                                        checkAllPagesAndChannels={this.checkAllPagesAndChannels}
                                        checkPagesAndChannels={this.checkPagesAndChannels}
                                        openModal={this.openModal}
                                        onClickHam={this.onClickHam}
                                        onSourceSwitch={this.onSourceSwitch}
                                        updateSources={this.updateSources}
                                        validateRss={this.validateRss}
                                        updatePhoto={this.updatePhoto}
                                        toggleFeedInfo={this.toggleFeedInfo}
                                        fb_sent={this.state.fb_sent}
                                        selectFeed={this.selectFeed}
                                        selectedFeed={this.state.feed_id}
                                        selectedSource={this.state.selected_source}
                                        wp_spinner={this.state.wp_spinner}
                                        updateUser={this.updateUser}
                                        appPropagateTeams={this.appPropagateTeams}
                                        selectSource={this.selectSource}
                                        showStarted={this.state.showStarted}
                                        hideStarted={this.hideStarted}
                                        dontShowStarted={this.dontShowStarted}
                                        loadingSource={this.state.loadingSource}
                                        loadingSourceChange={this.loadingSourceChange}
                                        tags={this.state.tags}
                                        filteredTags={this.state.filteredTags}
                                        tagsLoadin={this.state.tagsLoading}
                                        handleTagsSearch={this.handleTagsSearch}
                                        tagsPageSize={this.state.tagsPageSize}
                                        deleteTag={this.deleteTag}
                                        tagId={this.state.tag_id}
                                        tagName={this.state.tag_name}
                                        handleTagsSort={this.handleTagsSort}
                                        sortTagsColumn={this.state.sortTagsColumn}
                                        searchTagsString={this.state.searchTagsString}
                                        //filteredTags={this.state.filteredTags}
                                        handleGetTags={this.handleGetTags}
                                        handleCreateTag={this.handleCreateTag}
                                        tagsOnlyNames={this.state.tagsOnlyNames}
                                        filterTags={this.filterTags}
                                        tagsLoading={this.state.tagsLoading}
                                        deleteSubscribersIds={this.state.deleteSubscribersIds}
                                        deleteSubscribersIndicator={this.state.deleteSubscribersIndicator}
                                        deleteSubscribersType={this.state.deleteSubscribersType}
                                        updateUserFromServer={this.updateUserFromServer}
                                        checkIfProjectPlanSelected={this.checkIfProjectPlanSelected}
                                        plansData={this.state.plansData}
                                        subscription_renewal_problem={this.state.selected_source_data && this.state.selected_source_data.name === 'Greska'}
                                        setDeleteSubscribersIndicator={this.setDeleteSubscribersIndicator}
                                        isodateToDate={this.isodateToDate}
                                        {...props}/>}/>
                                    {/*{ console.log('Local Storage: ',localStorage)}*/}
                                    {/*{ console.log('user in app.js: ', this.state.user ) }*/}
                                    <Redirect to='/login'/>
                                    }
                                </Switch>
                            </div>
                        </div>
                    </Sentry.ErrorBoundary>
            }}
        </Offline>);
    }
}

export default App;